export default [
	{	path: "/timetables/placements/:datefrom?/:dateto?",
		component: () => import("../views/Timetables/Placements/Home.vue"),
		meta: {
			hasmainmenu: true
		}
	},
	{	path: "/timetables/placements/event/:ttroom_id",
		component: () => import("../views/Timetables/Placements/Event.vue"),
		meta: {
			hasmainmenu: true
		}
	},
    {
		path: "/placement-providers",
		component: () => import("../views/Settings/PlacementProviders/Home.vue"),
		meta: {
			hasmainmenu: false,
		}
	},
	{
		path: "/placement-providers/:placementprovider_id/:type?",
		component: () => import("../views/Settings/PlacementProviders/Edit.vue"),
        meta: {
			hasmainmenu: false,
            group: 'admin-timetable'
		}
	}
]
